module.exports = __webpack_public_path__ + "img/tonic-ska.1a1838c0.png";